<template>
  <v-dialog v-model="isActive" width="750" @keydown.esc="isActive = false" @keydown.left="prev" @keydown.right="next">

    <v-card height="90vh">

      <v-btn icon @click="isActive = false" right absolute dark class="mt-2" style="z-index: 10">
        <v-icon>clear</v-icon>
      </v-btn>

      <div class="gradient-container">
        <v-responsive width="100%" :aspect-ratio="16/9" class="gradient">

          <v-btn flat @click="prev" absolute left dark icon>
            <v-icon>chevron_left</v-icon>
          </v-btn>

          <v-btn flat @click="next" absolute right dark icon>
            <v-icon>chevron_right</v-icon>
          </v-btn>
        </v-responsive>

        <v-item-group v-model="onboarding" class="text-xs-center" mandatory>
          <v-item v-for="index in items.length" :key="index">
            <v-btn slot-scope="{ active, toggle }" @click="toggle" icon small flat :color="active ? 'primary' : '#0d25491f'">
              <v-icon size="18">fiber_manual_record</v-icon>
            </v-btn>
          </v-item>
        </v-item-group>

      </div>

      <v-window v-model="onboarding">
        <v-window-item v-for="(item, index) in items" :key="index">

          <v-responsive width="100%" :aspect-ratio="16/9" class="image-container">
            <v-card class="elevation-8">
              <v-img :src="item.image" width="100%" height="100%"/>
            </v-card>
          </v-responsive>

          <div class="mt-3 pa-4">
            <div class="display-1 font-weight-bold mb-2">{{ item.title }}</div>
            <div class="subheading">{{ item.text }}</div>
          </div>
        </v-window-item>
      </v-window>

    </v-card>
  </v-dialog>

</template>

<script>
import Toggleable from '@/mixins/toggleable'
//  TODO: finire testo guida
export default {
    name: 'OnBoardingDialog',
    mixins: [Toggleable],
    data () {
        return {
            items: [
                { title: this.$t('onboarding.avvisi.title'), text: this.$t('onboarding.avvisi.text'), image: require('@/assets/onboarding/avvisi.png') },
                { title: this.$t('onboarding.report.title'), text: this.$t('onboarding.report.text'), image: require('@/assets/onboarding/reports.png') },
                { title: this.$t('onboarding.prenotazioni.title'), text: this.$t('onboarding.prenotazioni.text'), image: require('@/assets/onboarding/calendario.png') },
                { title: this.$t('onboarding.map.title'), text: this.$t('onboarding.map.text'), image: require('@/assets/onboarding/mappa.png') },
                { title: this.$t('onboarding.clienti.title'), text: this.$t('onboarding.clienti.text'), image: require('@/assets/onboarding/clienti.png') },
                { title: this.$t('onboarding.convenzioni.title'), text: this.$t('onboarding.convenzioni.text'), image: require('@/assets/onboarding/convenzioni.png') },
                { title: this.$t('onboarding.magazzino.title'), text: this.$t('onboarding.magazzino.text'), image: require('@/assets/onboarding/magazzino.png') },
                { title: this.$t('onboarding.unita_mobili.title'), text: this.$t('onboarding.unita_mobili.text'), image: require('@/assets/onboarding/unita_mobili.png') },
                { title: this.$t('onboarding.tecnici.title'), text: this.$t('onboarding.tecnici.text'), image: require('@/assets/onboarding/tecnici.png') },
                { title: this.$t('onboarding.statistiche.title'), text: this.$t('onboarding.statistiche.text'), image: require('@/assets/onboarding/statistiche.png') }
            ],
            onboarding: 0
        }
    },
    mounted () {
        window.addEventListener('wheel', this.onScroll, { passive: true })
    },
    beforeDestroy () {
        window.removeEventListener('wheel', this.onScroll)
    },
    methods: {
        show () {
            this.isActive = true
        },
        next () {
            this.onboarding = (this.onboarding < this.items.length - 1) ? this.onboarding + 1 : 0
        },
        prev () {
            this.onboarding = (this.onboarding > 0) ? this.onboarding - 1 : this.items.length - 1
        },
        onScroll (e) {
            if (e.deltaY < 0 || e.deltaX < 0) { //  Up
                this.prev()
            } else if (e.deltaY > 0 || e.deltaX > 0) { //  Down
                this.next()
            }
        }
    }
}
</script>

<style scoped lang="scss">
  .gradient-container {
    position: absolute;
    left: 0;
    right: 0;

    .v-responsive {
      border-top-left-radius: 4px;
      border-top-right-radius: 4px;
    }

    .v-btn {
      z-index: 10;
      top: calc(50% - 18px);
    }
  }

  .image-container {
    .v-card {
      width: 80%;
      height: 80%;
      margin: 40px auto auto;
    }
  }

</style>
